<div class="gradient-blobs">
  <div class="blob blob-1"></div>
  <div class="blob blob-2"></div>
  <div class="blob blob-3"></div>
  <div class="blob blob-4"></div>
  <div class="blob blob-5"></div>
  <div class="blob blob-6"></div>
  <div class="blob blob-7"></div>
</div>

<!-- Hero Section -->
<section class="hero">
  <div class="hero-content">
    <div class="hero-left">
      <span class="hero-label">Professional AI Tool</span>
      <h1 class="hero-title">
        Create realistic <br />
        AI characters
      </h1>
      <h2 class="hero-subtitle">
        No skill required, uncensored and free to use
      </h2>
      <a class="gradient-button gradient-button--large" routerLink="/create">
        <mat-icon style="margin-right: 8px">auto_awesome</mat-icon>

        Create Your Character
      </a>
    </div>
    <div class="hero-right">
      <div class="hero-image-wrapper">
        <img
          ngSrc="assets/59100e98-b3c3-48c7-b2f8-58142803cb3a.webp"
          alt="AI generated character on a beach"
          class="hero-image"
          fill
          priority
          fetchpriority="high"
        />

        <!-- Prompt cards overlaid on hero image -->
        <div class="prompt-card prompt-card--top-left">
          <p class="prompt-card__text">
            A stunning woman standing on a sunlit beach during golden hour,
            wearing an elegant white bikini
          </p>
          <span class="prompt-card__button">Create image</span>
        </div>

        <div class="prompt-card prompt-card--small prompt-card--top-right">
          <p class="prompt-card__text">Change hair color to red</p>
        </div>

        <div class="prompt-card prompt-card--small prompt-card--mid-left">
          <p class="prompt-card__text">Add a confident, relaxed pose</p>
        </div>

        <div class="prompt-card prompt-card--bottom-right">
          <p class="prompt-card__text">
            Woman walking on beach, waves crashing in the background, wind
            blowing her hair
          </p>
          <span class="prompt-card__button">Create Video</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Gallery Section -->
<section class="section-gallery">
  <h2 class="section-heading section-heading--gradient">
    Endless possibilities. Create your own content.
  </h2>

  <div class="hero-gallery">
    <div class="adult-content-toggle">
      <mat-slide-toggle
        [checked]="showAdultContent()"
        (change)="showAdultContent.set($event.checked); onAdultContentToggle()"
      >
        View 18+
      </mat-slide-toggle>
    </div>
    <div class="gallery-container" #galleryContainer>
      <!-- First Row -->
      <div
        class="gallery-track"
        [style.transform]="'translateX(' + scrollPosition + 'px)'"
      >
        @for (media of promoMediaRow1; track media.id) {
          <div
            class="media-item"
            [class.portrait]="media.media.mediaType === 'IMAGE'"
            [class.landscape]="media.media.mediaType === 'VIDEO'"
          >
            @if (media.media.mediaType === "IMAGE") {
              <img
                [src]="media.media.mediaUrl"
                [alt]="
                  !media.isSafe && !isMediaRevealed()
                    ? 'Blurred image. Click to reveal'
                    : media.altText || 'Promo image ' + media.id
                "
                class="gallery-media"
                [class.blurred]="!media.isSafe && !isMediaRevealed()"
                loading="lazy"
              />
            } @else if (media.media.mediaType === "VIDEO") {
              <video
                [src]="media.media.mediaUrl"
                class="gallery-media"
                [class.blurred]="!media.isSafe && !isMediaRevealed()"
                [muted]="true"
                loop
                autoplay
                playsinline
                loading="lazy"
              ></video>
            }

            @if (!media.isSafe && !isMediaRevealed()) {
              <div class="reveal-overlay" (click)="revealAllMedia()">
                <div class="reveal-text">Click to reveal</div>
              </div>
            } @else {
              <a
                class="gallery-generate"
                routerLink="/create"
                [queryParams]="{
                  promptId: promptIdFromUrl(media.media.mediaUrl),
                }"
                [state]="{ media: media.media }"
                aria-label="Generate images like this"
              >
                <mat-icon>auto_awesome</mat-icon>
                <span>Generate this</span>
              </a>
            }
          </div>
        }
        @if (isLoading) {
          <div class="loading-indicator">
            <div class="loading-spinner"></div>
          </div>
        }
      </div>

      <!-- Second Row -->
      <div
        class="gallery-track"
        [style.transform]="'translateX(' + scrollPosition + 'px)'"
      >
        @for (media of promoMediaRow2; track media.id) {
          <div
            class="media-item"
            [class.portrait]="media.media.mediaType === 'IMAGE'"
            [class.landscape]="media.media.mediaType === 'VIDEO'"
          >
            @if (media.media.mediaType === "IMAGE") {
              <img
                [src]="media.media.mediaUrl"
                [alt]="
                  !media.isSafe && !isMediaRevealed()
                    ? 'Blurred image. Click to reveal'
                    : media.altText || 'Promo image ' + media.id
                "
                class="gallery-media"
                [class.blurred]="!media.isSafe && !isMediaRevealed()"
                loading="lazy"
              />
            } @else if (media.media.mediaType === "VIDEO") {
              <video
                [src]="media.media.mediaUrl"
                class="gallery-media"
                [class.blurred]="!media.isSafe && !isMediaRevealed()"
                [muted]="true"
                loop
                autoplay
                playsinline
              ></video>
            }

            @if (!media.isSafe && !isMediaRevealed()) {
              <div class="reveal-overlay" (click)="revealAllMedia()">
                <div class="reveal-text">Click to reveal</div>
              </div>
            } @else {
              <a
                class="gallery-generate"
                routerLink="/create"
                [queryParams]="{
                  promptId: promptIdFromUrl(media.media.mediaUrl),
                }"
                [state]="{ media: media.media }"
                aria-label="Generate images like this"
              >
                <mat-icon>auto_awesome</mat-icon>
                <span>Generate this</span>
              </a>
            }
          </div>
        }
      </div>
    </div>
  </div>
</section>

<!-- Feature 1: Create character exactly how you want -->
<!--<section class="feature-showcase">-->
<!--  <h2 class="section-heading section-heading&#45;&#45;gradient-2">-->
<!--    Create character exactly how you want-->
<!--  </h2>-->
<!--  <div class="feature-showcase__image-container">-->
<!--    <div class="feature-showcase__placeholder"></div>-->
<!--  </div>-->
<!--</section>-->

<!-- Feature 2: Bring your creations alive -->
<section class="feature-split">
  <div class="feature-split__media">
    <video #heroVideo loop autoplay muted playsinline>
      <source src="assets/output.web.mp4" type="video/mp4" />
    </video>
  </div>
  <h2 class="feature-split__text">
    <span class="feature-split__gradient">Bring your creations alive</span>
    with high quality images or videos
  </h2>
</section>

<!-- Feature 3: Keep your character consistent -->
<section class="feature-split feature-split--reverse">
  <h2 class="feature-split__text">
    Keep your character
    <span class="feature-split__gradient">consistent</span> across generations
  </h2>
  <div class="feature-split__images-grid">
    <div class="feature-split__image feature-split__image--first">
      <img src="assets/con2.webp" alt="Consistent character example 1" />
    </div>
    <div class="feature-split__image feature-split__image--middle">
      <img src="assets/con1.webp" alt="Consistent character example 2" />
    </div>
    <div class="feature-split__image feature-split__image--last">
      <img src="assets/con3.webp" alt="Consistent character example 3" />
    </div>
  </div>
</section>

<!-- Model Showcase (reuses .features-section / .features-grid / .feature-card) -->
<section class="features-section">
  <h2 class="section-heading section-heading--gradient">
    Powered by the best AI models
  </h2>
  <p class="features-section__subtitle">
    Every model has its own strengths — find the perfect style for your idea.
  </p>

  <div class="features-grid">
    @for (showcase of modelShowcases; track showcase.slug) {
      <a
        class="feature-card model-card"
        [routerLink]="['/ai-model-overview']"
        [fragment]="showcase.slug"
        mat-ripple
      >
        <div class="model-card__previews">
          @for (media of modelPreviews()[showcase.slug] ?? []; track media.id) {
            @if (media.mediaType === MediaType.Video) {
              <video
                class="model-card__preview"
                [src]="media.mediaUrl"
                muted
                loop
                autoplay
                playsinline
                preload="metadata"
              ></video>
            } @else {
              <img
                class="model-card__preview"
                [src]="media.mediaUrl"
                [alt]="showcase.option.name + ' AI model example'"
                loading="lazy"
              />
            }
          } @empty {
            @for (placeholder of [0, 1]; track placeholder) {
              <div
                class="model-card__preview model-card__preview--skeleton"
                aria-hidden="true"
              ></div>
            }
          }
        </div>

        <div class="model-card__head">
          <mat-icon class="model-card__icon"
            >{{ showcase.option.icon }}
          </mat-icon>
          <h3 class="feature-card__title">{{ showcase.option.name }}</h3>
          @if (showcase.option.uncensored) {
            <span class="model-card__badge">Uncensored</span>
          }
        </div>

        <p class="feature-card__description">{{ showcase.tagline }}</p>

        <span class="feature-card__link">View model →</span>
      </a>
    }
  </div>

  <div class="features-section__cta">
    <a class="gradient-button" routerLink="/ai-model-overview">
      See all AI models
    </a>
  </div>
</section>

<!-- CTA -->
<section class="hero hero--centered" style="padding-top: 36px">
  <a class="gradient-button" routerLink="/create">
    Join and create your character now
  </a>
</section>

@if (environment.site === "ALIVEAI" || environment.site === "LOVELAB") {
  <div
    style="
      display: flex;
      gap: 4px;
      align-items: center;
      justify-content: center;
    "
  >
    <a style="margin-top: 32px" mat-button routerLink="/uncensored-ai">
      Learn about AI character creation
    </a>

    <a
      style="margin-top: 32px"
      mat-button
      href="https://www.youtube.com/watch?v=Jv8iPVQNAWg"
      target="_blank"
      rel="noopener noreferrer"
    >
      Watch the video tutorial
    </a>
  </div>

  <!-- SEO Buttons Section -->
  <section class="features-section">
    <h3 class="section-heading section-heading--gradient-2">
      Explore All Features
    </h3>
    <p class="features-section__subtitle">
      Discover everything {{ environment.name }} can do for you
    </p>

    <div class="features-grid">
      @for (feature of ALIVEAI_FEATURES; track feature) {
        <a [routerLink]="feature.route" class="feature-card" mat-ripple>
          <h4 class="feature-card__title">{{ feature.title }}</h4>
          <p class="feature-card__description">{{ feature.description }}</p>
          <span class="feature-card__link">Learn more →</span>
        </a>
      }
    </div>

    <div class="features-section__cta">
      <a class="gradient-button" routerLink="/create"> Start creating now </a>
    </div>
  </section>
}

<app-social-partners></app-social-partners>

<!-- Explore Section -->
<section class="explore-section">
  <h3 class="section-heading section-heading--gradient-2">
    See What Others Are Creating
  </h3>
  <div class="explore-buttons">
    <a routerLink="/posts" matButton="tonal">
      <mat-icon>groups</mat-icon>
      Browse Community Posts
    </a>
    <a routerLink="/updates" matButton="tonal">
      <mat-icon>new_releases</mat-icon>
      View Updates
    </a>
  </div>
</section>

<!-- Developer / API Section -->
<section class="api-section">
  <div class="api-section__card">
    <mat-icon class="api-section__icon">code</mat-icon>
    <h3 class="api-section__title">Built for Developers</h3>
    <p class="api-section__description">
      Use our powerful API to build your own private or enterprise solutions.
      Integrate AI image and video generation directly into your products with
      full programmatic control.
    </p>
    <a
      class="gradient-button"
      href="https://api-doc.aliveai.app/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <mat-icon>open_in_new</mat-icon>
      View API Documentation
    </a>
  </div>
</section>

<!-- Social Media Section -->
<section class="social-media-section">
  <h4 class="social-title">Follow Us</h4>
  <div class="social-buttons">
    <a
      href="https://discord.com/invite/PNMsFw7eMN"
      target="_blank"
      rel="noopener noreferrer"
      class="social-button discord"
      mat-icon-button
      aria-label="Discord"
    >
      <mat-icon svgIcon="discord" class="social-icon"></mat-icon>
    </a>
    <a
      href="https://instagram.com/aliveai.app"
      target="_blank"
      rel="noopener noreferrer"
      class="social-button instagram"
      mat-icon-button
      aria-label="Instagram"
    >
      <mat-icon svgIcon="instagram" class="social-icon"></mat-icon>
    </a>
    <a
      href="https://www.reddit.com/r/aipornisthefuture/"
      target="_blank"
      rel="noopener noreferrer"
      class="social-button reddit"
      mat-icon-button
      aria-label="Reddit"
    >
      <mat-icon svgIcon="reddit" class="social-icon"></mat-icon>
    </a>
  </div>
</section>

<footer class="footer">
  <p>&copy; 2026 {{ environment.domain }}. All rights reserved.</p>
  <p>Quadra Labs Ltd, Malta</p>
  <div class="footer-links">
    <a routerLink="/policy" fragment="terms" class="footer-link"
      >Terms of Service</a
    >
    <a routerLink="/policy" fragment="privacy" class="footer-link"
      >Privacy Policy</a
    >
    <a routerLink="/policy" fragment="usc-2257" class="footer-link"
      >18 U.S.C. 2257 Exemption</a
    >
  </div>
</footer>
